import { useTranslation } from 'next-i18next'
import { useContext } from 'react'
import { Select } from 'components/common/Select/SelectV2'
import { SortByContext } from './Filters/SortByContext'

export const SortBy = () => {
  const { t } = useTranslation('common')
  const { currentRefinement, options, refine } = useContext(SortByContext)

  return (
    <Select
      options={options}
      value={currentRefinement}
      onSave={(val) => {
        refine(val)
      }}
      label={`${t('sortBy')} ${
        options.find((x) => x.value === currentRefinement)?.label
      }`}
    />
  )
}
